export class StaysWidgetHelperBaseComponent {
  isSubmitted = false;
  destinationErrorMessage = '';
  datesErrorMessage = '';
  tooFewPeopleErrorMessage = '';
  tooFewRoomsErrorMessage = '';
  maxDatesErrorMessage = '';
  errorCount = 0;
  firstErrorElement!: HTMLElement | null;
  clearAllErrors(): void {
    this.isSubmitted = false;
    this.destinationErrorMessage = '';
    this.datesErrorMessage = '';
    this.tooFewPeopleErrorMessage = '';
    this.tooFewRoomsErrorMessage = '';
    this.maxDatesErrorMessage = '';
    this.errorCount = 0;
    this.firstErrorElement = null;
  }
}
